import { mapGetters, mapActions } from "vuex";
import { metersToFeet, calculateDistance } from "@/helpers/surveyingUtils";
import { SIGHT_HEIGHT } from "@/helpers/constants";
import {
  ErrorMeasurementTolerance,
  IdealMeasurementTolerance,
  PointName,
  CurveConstants
} from "@/data/content";

const stepValidationMixin = {
  computed: {
    ...mapGetters([
      "getSections",
      "getPointPositions",
      "getInstrumentHeight",
      "getErrorMessage",
      "getAtPointName"
    ])
  },
  methods: {
    ...mapActions(["setErrorMessage"]),
    validateStepCompletion(sectionIndex, stepIndex) {
      const step = this.getSections[sectionIndex].steps[stepIndex];

      if (step.id.startsWith("STAKE_OUT_")) {
        const pointName = step.id.replace("STAKE_OUT_", "");
        if (this.getPointPositions[pointName] === null) {
          this.setErrorMessage(
            `You have not staked out the ${pointName} point yet.`
          );
          return false;
        }
        // No height entry steps are used in this lab, but leaving this condition in case we add them later
      } else if (step.id.startsWith("ENTER_INSTRUMENT_HEIGHT")) {
        const expectedHeight = Number(metersToFeet(SIGHT_HEIGHT).toFixed(2));
        const enteredHeight = this.getInstrumentHeight;
        if (enteredHeight !== expectedHeight) {
          this.setErrorMessage(
            `The entered instrument height is ${enteredHeight} feet, but it must be ${expectedHeight} feet.`
          );
          return false;
        } else {
          // hide the height input after the height input step is validated
          this.$refs.surveyingScene.$refs.dataOutput.hideHeightInput();
        }
      } else if (step.id.startsWith("MEASURE")) {
        const pointName = step.id.replace("MEASURE_ERROR_", "");
        const calculatedTolerance = ErrorMeasurementTolerance[pointName];
        let measuredError = 0;

        if (pointName === "CS2") {
          measuredError = calculateDistance(
            this.getPointPositions[PointName.CS],
            this.getPointPositions[PointName.CS2]
          );
        } else {
          // This will be for the MP point
          const measuredDistance = calculateDistance(
            this.getPointPositions[PointName.MP],
            this.getPointPositions[PointName.PI]
          );

          const expectedDistance = CurveConstants.Es;
          measuredError = Math.abs(measuredDistance - expectedDistance);
        }
        if (measuredError > calculatedTolerance) {
          this.setErrorMessage(
            `The measured error is ${metersToFeet(measuredError).toPrecision(
              4
            )} ft.  Ideally it should be under ${
              IdealMeasurementTolerance[pointName]
            } ft, but up to ${metersToFeet(calculatedTolerance).toPrecision(
              3
            )} ft is acceptable to proceed.`
          );
          return false;
        }
      }
      // If all validations pass, clear the error message
      this.setErrorMessage("");
      return true;
    },
    isStepDisabled(sectionIndex, stepIndex) {
      const sections = this.getSections;
      let isDisabled = false;
      for (let i = 0; i <= sectionIndex; i++) {
        const stepLimit =
          i === sectionIndex ? stepIndex : sections[i].steps.length;
        for (let j = 0; j < stepLimit; j++) {
          if (!sections[i].steps[j].completed) {
            isDisabled = true;
          }
        }
      }
      return isDisabled;
    }
  }
};

export default stepValidationMixin;
